import { useEffect, useState } from 'react';
import { fetchImageList } from './ApiRequests';
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Typography, Box,
  List, ListItem
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

export default function ListView({ authToken, onLogout }) {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const filter = params.get('filter') || 'all';

  useEffect(() => {
    if (!authToken) return;
    fetchImageList(filter, authToken, onLogout)
      .then(setItems)
      .catch(e => console.error(e));
  }, [filter, authToken]);

  return (
    <Box p={2}>
      <Typography variant="h5" gutterBottom>
        Images ({filter})
      </Typography>

      {!authToken && (
        <Typography color="error" variant="body1">
          Please sign in
        </Typography>
      )}

      {authToken && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>S3 Path</TableCell>
                <TableCell>Preview</TableCell>
                <TableCell>Label ({process.env.REACT_APP_LABEL_NAME}) [User]</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map(it => (
                <TableRow
                  key={it.s3_path}
                  hover
                  onClick={() => navigate(`/image?s3_path=${encodeURIComponent(it.s3_path)}`)}
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell sx={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {it.s3_path}
                  </TableCell>
                  <TableCell>
                    <img src={`/v1/image?s3_path=${encodeURIComponent(it.s3_path)}`} alt="thumb" style={{ height: 80 }} />
                  </TableCell>
                  <TableCell>
                    <List>
                      {it.label_data.map((ld, i) => (
                        <ListItem key={i} sx={{ display: "list-item" }}>
                          <Typography>
                            {ld.label ?? ""} [{ld.user ?? ""}]
                          </Typography>
                        </ListItem>
                      ))}
                    </List>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
